export default "__VITE_ASSET__ykX0QBwebHfvDi1hUiJzog__"